<template>
  <div>
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>实时政策</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content">
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
      >
        <el-form-item label="搜索">
          <el-input v-model="key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList()">查询</el-button>
          <el-button type="success" @click="addClick">新增</el-button>
        </el-form-item>
      </el-form>
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>实时政策</span>
        </div>
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width: 100%"
        >
          <el-table-column prop="title" label="标题"></el-table-column>
          <el-table-column prop="viewCount" label="浏览量" width="90"></el-table-column>
          <el-table-column prop="author" label="作者"></el-table-column>
          <el-table-column prop="sort" label="排序" width="80"></el-table-column>
          <el-table-column label="置顶" width="70">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.isTop" type="danger">是</el-tag>
              <el-tag v-else type="info">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="publishTime" label="发布时间" width="160"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑" placement="top">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit"
                    @click="editClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-delete"
                    @click="delClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" style="margin-top: 20px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <el-dialog
      :title="form.id > 0 ? '编辑实时政策' : '添加实时政策'"
      :visible.sync="dialogVisible"
      @opened="dialogOpened()"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm('form')"
      >
        <el-form-item
          label="标题"
          prop="title"
          :rules="[
            { required: true, message: '请输入标题' },
            { min: 2, max: 30, message: '标题最少2字，最大30字' },
          ]"
        >
          <el-input v-model="form.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="图片" prop="imgUrl" :rules="[{ required: true, message: '请输入图片' }]">
          <div id="uploadBtnPolicy" class="uploader uploader-warning"></div>
          <img :src="domain + form.imgUrl" style="height: 40px; position: relative; left: 10px; top: 20px"
            v-if="form.imgUrl"
          />
          <div class="uploader-text">* 图片尺寸：推荐372px*279px</div>
        </el-form-item>
        <el-form-item label="作者" prop="author">
          <el-input v-model="form.author" placeholder="请输入作者"></el-input>
        </el-form-item>
        <el-form-item label="排序字段" prop="sort">
          <el-input v-model.number="form.sort" placeholder="请输入排序字段"></el-input>
        </el-form-item>
        <el-form-item label="浏览量" prop="viewCount">
          <el-input v-model.number="form.viewCount" placeholder="请输入浏览量"></el-input>
        </el-form-item>
        <el-form-item label="发布时间">
          <el-date-picker v-model="form.publishTime" type="datetime" style="width:100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="置顶">
          <el-switch v-model="form.isTop"></el-switch>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <vue-ueditor-wrap v-model="form.content" :config="editorConfig"></vue-ueditor-wrap>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import VueUeditorWrap from "vue-ueditor-wrap";

export default {
  name: "realTimePolicy",
  components: { VueUeditorWrap },
  data() {
    return {
      editorConfig: {
        initialFrameHeight: 500,
        initialFrameWidth: "100%",
        UEDITOR_HOME_URL: url.getUEConfig(),
        serverUrl: url.getUE(),
      },
      domain: url.getDomain(),
      key: "",
      query: { articleType: "2" },
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {},
      dialogVisible: false,
      submiting: false,
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    addClick() {
      this.form = {
        articleType: 2,
        sort: 0,
        viewCount: 0,
        isTop: false,
      };
      this.dialogVisible = true;
    },
    getList() {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      params.key = _this.key;
      var link = url.getStrategy("getlist_strategy");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    selList() {
      this.currentPage4 = 1;
      this.getList();
    },
    dialogOpened() {
      var _this = this;
      if ($("#uploadBtnPolicy input").length == 0) {
        $("#uploadBtnPolicy").uploader({
          url: url.getUpload(),
          text: "上传图片",
          fileExts: "jpg;png",
          type: "dialog",
          coverParams: {
            targetWidth: 372,
            targetHeight: 279,
          },
          maxSize: 1024 * 1024 * 1,
          onSuccess: function (data) {
            _this.$set(_this.form, "imgUrl", data.relativeName);
          },
        });
      }
    },
    submitForm(formName) {
      var _this = this;
      var link = url.getStrategy("save_strategy");
      var info = this.form;
      info.articleType = 2;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({ type: "success", message: res.msg });
            } else {
              _this.$message({ type: "error", message: res.msg });
            }
          });
        }
      });
    },
    editClick(row) {
      this.form = Object.assign({}, row);
      this.dialogVisible = true;
    },
    delClick(row) {
      var _this = this;
      var link = url.getStrategy("delete_strategy");
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        concelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          $.post(link, { id: row.id }, (res) => {
            if (res.status) {
              _this.getList();
              _this.$message({ type: "success", message: res.msg });
            } else {
              _this.$message({ type: "error", message: res.msg });
            }
          });
        })
        .catch(() => {
          this.$message({ type: "info", message: "已取消删除" });
        });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.el-form-item--small.el-form-item {
  margin-right: 0px;
}
.el-button--primary {
  margin-left: 10px;
}
</style>
